import { FormLayout } from "../../../../layouts/form";
import { FormLabel, Grid, Radio, RadioGroup, TextField, Tooltip, Typography } from "@mui/material";
import InputSlider from "../../../../components/inputSlider";
import { useEffect, useState } from "react";
import { FormControl, OutlinedInput, MenuItem, Select, InputLabel, FormControlLabel } from "@mui/material";
import { NotificationManager } from "react-notifications";
import { CompaniesService } from "../../../../services/companies";
import { VehiclesService } from "../../../../services/vehicles";
import { useContext } from 'react';
import { AuthContext } from '../../../../contexts/auth';
import { TrackersService } from "../../../../services/trackers";
import { green, grey } from "@mui/material/colors";

export const VehicleForm = ({ onClose, defaultValues }) => {
    const companiesService = new CompaniesService();
    const vehicleService = new VehiclesService();
    const trackersService = new TrackersService();
    const [companies, setCompanies] = useState([]);
    const [plants, setPlants] = useState([]);
    const [saving, setSaving] = useState(false);
    const [disableSaving, setDisableSaving] = useState(false);
    const { userType, userCompanyId } = useContext(AuthContext);
    const [selectedCompanyId, setSelectedCompanyId] = useState();
    const [selectPlant, setSelectPlant] = useState();
    const [powerTensionNominal, setPowerTensionNominal] = useState("");

    const handleChange = (event) => {
        setSelectedCompanyId(event.target.value);
    }

    const handleChangePlant = (event) => {
        setSelectPlant(event.target.value);
    }

    useEffect(() => {
        getVehicles();
        if (userType !== 'SystemAdmin') {
            let listPlants = [];
            companiesService.getCompany(userCompanyId).then(res => {
                const companiesList = [res.data];
                setCompanies(companiesList);
                res.data.blueprint.forEach((element, index) => {
                    listPlants.push({ value: element.toUpperCase(), id: index })
                });
                setPlants(listPlants);
            }).catch(err => {
            });
        } else {
        }
        setSelectedCompanyId(userCompanyId);
    }, []);


    const validateFields = (fields) => {
        if (fields.name === "" ||
            fields.model === "" ||
            fields.temperatureIntThreshold === "" ||
            fields.humidityThreshold === "" ||
            fields.cO2Threshold === "" ||
            fields.vibrationThreshold === "") {
            NotificationManager.warning("Cadastro incompleto!", "", 3000);
            return false;

        } else {
            if (!defaultValues && powerTensionNominal === "") {
                NotificationManager.warning("Cadastro incompleto!", "", 3000);
                return false;
            } else {
                return true;
            }
        }
    }

    const handleUpdateSuccess = () => {
        NotificationManager.success('Informações do veículo atualizadas com sucesso.', "", 3000);
        setSaving(false);
        onClose();
    }

    const handleCreationSuccess = () => {
        NotificationManager.success('Veículo criado com sucesso.', "", 3000);
        NotificationManager.warning('Vincule com um rastreador.', "", 3000);
        getVehicles();
        setSaving(false);
        onClose();
    }

    const getVehicles = () => {
        if (defaultValues) {
            vehicleService.getNotLinkedById(defaultValues.id)
                .then(response => {
                    if (response.data === false) {
                        setDisableSaving(true);
                        NotificationManager.warning('Vincule com um rastreador.', "", 3000);
                    } else {
                        setDisableSaving(false);
                    }
                }).catch(error => {
                    console.error(error);
                });
        }

    };

    const handleVehicleSave = (formData) => {

        var dataList = [];
        const data = new FormData(formData);
        const newVehicle = {
            "plate": data.get('platetf'),
            "model": data.get('modeltf'),
            "temperatureMaxThreshold": data.get('temperatureMaxThresholdCritical'),
            "temperatureMinThreshold": data.get('temperatureMinThresholdCritical'),
            "humidityMaxThreshold": data.get('humidityMaxThresholdCritical'),
            "humidityMinThreshold": data.get('humidityMinThresholdCritical'),
            "cO2MaxThreshold": data.get('cO2MaxThresholdCritical'),
            "cO2MinThreshold": data.get('cO2MinThresholdCritical'),
            "vibrationMaxThreshold": data.get('vibrationMaxThresholdCritical'),
            "vibrationMinThreshold": data.get('vibrationMinThresholdCritical'),
            "companyId": selectedCompanyId,
            "typeOperation": data.get('typeOperation'),
            "powerTension_nominal": powerTensionNominal,
            "blueprint": data.get('blueprint')
        };
        if (!validateFields(newVehicle)) {
            setSaving(false);
            return;
        }
        setSaving(true);
        setDisableSaving(true);

        if (defaultValues) {
            newVehicle.id = defaultValues.id;
            const newVehicleUpdate = {
                "id": defaultValues.id,
                "plate": data.get('platetf'),
                "model": data.get('modeltf'),
                "temperatureMaxThreshold": defaultValues.temperatureMaxThreshold,
                "temperatureMinThreshold": defaultValues.temperatureMinThreshold,
                "humidityMaxThreshold": defaultValues.humidityMaxThreshold,
                "humidityMinThreshold": defaultValues.humidityMinThreshold,
                "cO2MaxThreshold": defaultValues.cO2MaxThreshold,
                "cO2MinThreshold": defaultValues.cO2MinThreshold,
                "vibrationMaxThreshold": defaultValues.vibrationMaxThreshold,
                "vibrationMinThreshold": defaultValues.vibrationMinThreshold,
                "temperatureMaxThreshold_FormUpdate": data.get('temperatureMaxThresholdCritical'),
                "temperatureMinThreshold_FormUpdate": data.get('temperatureMinThresholdCritical'),
                "humidityMaxThreshold_FormUpdate": data.get('humidityMaxThresholdCritical'),
                "humidityMinThreshold_FormUpdate": data.get('humidityMinThresholdCritical'),
                "cO2MaxThreshold_FormUpdate": data.get('cO2MaxThresholdCritical'),
                "cO2MinThreshold_FormUpdate": data.get('cO2MinThresholdCritical'),
                "vibrationMaxThreshold_FormUpdate": data.get('vibrationMaxThresholdCritical'),
                "vibrationMinThreshold_FormUpdate": data.get('vibrationMinThresholdCritical'),
                "companyId": selectedCompanyId,
                "typeOperation": defaultValues.typeOperation,
                "powerTension_nominal": powerTensionNominal === "" ? defaultValues.powerTension_Nominal : powerTensionNominal,
                "blueprint": data.get('blueprint')
            };
            vehicleService.updateVehicle(newVehicleUpdate).then(() => {

                dataList = {
                    Id: newVehicle.id,
                    Model: newVehicle.model,
                    Plate: newVehicle.plate,
                    TemperatureMaxThreshold_FormUpdate: newVehicle.temperatureMaxThreshold,
                    TemperatureMinThreshold_FormUpdate: newVehicle.temperatureMinThreshold,
                    HumidityMaxThreshold_FormUpdate: newVehicle.humidityMaxThreshold,
                    HumidityMinThreshold_FormUpdate: newVehicle.humidityMinThreshold,
                    CO2MaxThreshold_FormUpdate: newVehicle.cO2MaxThreshold,
                    CO2MinThreshold_FormUpdate: newVehicle.cO2MinThreshold,
                    VibrationMaxThreshold_FormUpdate: newVehicle.vibrationMaxThreshold,
                    VibrationMinThreshold_FormUpdate: newVehicle.vibrationMinThreshold,
                    CompanyId: newVehicle.companyId,

                    IsRemoved: false,
                }

                setTimeout(function () {
                    trackersService.uploadParm(dataList).then(() => {

                    }).catch((error) => {
                        console.error(error);
                        setSaving(false);
                        setDisableSaving(false);
                    });
                }, 5000);
                handleUpdateSuccess();
            }).catch((error) => {
                setSaving(false);
                setDisableSaving(false);
            });
        } else {
            const newVehicleCreated = {
                "plate": data.get('platetf'),
                "model": data.get('modeltf'),
                "temperatureMaxThreshold": 0,
                "temperatureMinThreshold": 0,
                "humidityMaxThreshold": 0,
                "humidityMinThreshold": 0,
                "cO2MaxThreshold": 0,
                "cO2MinThreshold": 0,
                "vibrationMaxThreshold": 0,
                "vibrationMinThreshold": 0,
                "companyId": selectedCompanyId,
                "typeOperation": "",
                "powerTension_nominal": powerTensionNominal,
                "blueprint": selectPlant
            };
            vehicleService.createVehicle(newVehicleCreated).then((res) => {
                handleCreationSuccess();
            }).catch((error) => {
                setSaving(false);
                setDisableSaving(false);
            });
        }
    }

    const formatInput = (event) => {
        let temp = event.target.value;
        temp = temp.trim();
        event.target.value = temp;
    }

    const inputPropsTextFiel = {
        style: {
            height: 20
        }
    }

    const radioCustom = {
        color: grey[400],
        marginRight: 1,
        marginLeft: 2,
        height: 20,
        width: 20,
        '&.Mui-checked': {
            color: green[700],
            height: 20,
            width: 20,
            marginLeft: 2,
            marginRight: 1,
            backgroundColor: "#efffe2",
            ":hover": {
                color: green[500],
            }

        },
    }

    return (
        <FormLayout onSaveClick={handleVehicleSave} saving={saving} disableButton={disableSaving}>
            <Grid container spacing={2}>
                <Grid item xs={12} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <Grid item xs={4}>
                        <TextField
                            id="platetf"
                            defaultValue={defaultValues && defaultValues.plate}
                            name="platetf"
                            label="Placa"
                            fullWidth
                            variant="outlined"
                            required
                            inputProps={inputPropsTextFiel}
                            onBlur={formatInput}
                            size='small'
                            sx={{
                                boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                                borderRadius: '6px',
                                width: 265
                            }}
                        />
                    </Grid>
                    <Grid item xs={4} marginLeft="35px">
                        <TextField
                            id="modeltf"
                            defaultValue={defaultValues && defaultValues.model}
                            name="modeltf"
                            label="Modelo"
                            fullWidth
                            variant="outlined"
                            required
                            inputProps={inputPropsTextFiel}
                            onBlur={formatInput}
                            size='small'
                            sx={{
                                boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                                borderRadius: '6px',
                                width: 265
                            }} />
                    </Grid>
                    <Grid item xs={4} marginLeft="35px">
                        <FormControl sx={{ width: 265 }}>
                            <InputLabel htmlFor="company-select-id-label">Empresa</InputLabel>
                            <Select
                                labelId="company-select-id-label"
                                name="companyId"
                                defaultValue={defaultValues ? defaultValues.companyId : userCompanyId}
                                input={<OutlinedInput label="Empresa" />}
                                onChange={handleChange}
                                style={{
                                    height: 36,
                                    boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                                    borderRadius: '6px',
                                }}
                            >
                                {companies.map(c => {
                                    return <MenuItem value={c.id}>{c.name}</MenuItem>
                                })}

                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item xs={12} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <Grid item xs={6}>
                        <TextField id="typeOperation"
                            defaultValue={!defaultValues ? " " : defaultValues.typeOperation}
                            name="typeOperation"
                            label="Tipo de operação"
                            fullWidth
                            variant="outlined"
                            disabled={true}
                            inputProps={inputPropsTextFiel}
                            size='small'
                            sx={{
                                boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                                borderRadius: '6px',
                                width: 410
                            }} />
                    </Grid>
                    <Grid item xs={6} marginLeft="45px">
                        <FormControl>
                            <InputLabel htmlFor="plant-select-id-label" size="small" required>Plantas</InputLabel>
                            <Select
                                required
                                labelId="plant-select-id-label"
                                name="blueprint"
                                defaultValue={defaultValues ? defaultValues.blueprint : ""}
                                input={<OutlinedInput label="Planta" />}
                                onChange={handleChangePlant}
                                style={{
                                    height: 36,
                                    width: 410,
                                    boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                                    borderRadius: '6px',
                                }}
                            >
                                {plants.map(c => {
                                    return <MenuItem value={c.value}>{c.value}</MenuItem>
                                })}

                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Tooltip title="Tensão da Bateria do Baú">
                        <FormControl>

                            <FormLabel id="powerTension_nominal_label" required style={{ color: "black", fontWeight: 400, fontSize: '16px' }} >Tensão da Bateria do Baú</FormLabel>
                            <RadioGroup
                                row
                                onChange={(element) => setPowerTensionNominal(element.target.value)}
                                defaultValue={!defaultValues ? "" : defaultValues.powerTension_Nominal === "12" ? "12" : defaultValues.powerTension_Nominal === "24" ? "24" : ""}
                            >
                                <FormControlLabel
                                    value="12"
                                    required
                                    sx={{
                                        '& .MuiFormControlLabel-asterisk': { display: 'none' },
                                    }}
                                    control={
                                        <Radio
                                            sx={radioCustom}
                                        />
                                    }
                                    label="12V" />
                                <FormControlLabel
                                    value="24"
                                    required
                                    sx={{
                                        '& .MuiFormControlLabel-asterisk': { display: 'none' },
                                    }}
                                    control={
                                        <Radio
                                            sx={radioCustom}
                                        />
                                    }
                                    label="24V" />
                            </RadioGroup>
                        </FormControl>
                    </Tooltip>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">Limiares Críticos</Typography>
                </Grid>

                <Grid item xs={6}>
                    <InputSlider
                        label="Temperatura Interna Inferior Crítica (°C)"
                        name='temperatureMinThresholdCritical'
                        startValue={defaultValues ? defaultValues.temperatureMinThreshold : 0}
                        min={0.0}
                        max={100.0}
                        step={0.1}
                        disable={defaultValues ? false : true}

                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="Temperatura Interna Superior Crítica (°C)"
                        name='temperatureMaxThresholdCritical'
                        startValue={defaultValues ? defaultValues.temperatureMaxThreshold : 0}
                        min={0.0}
                        max={100.0}
                        step={0.1}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="Umidade Inferior Crítica (%)"
                        name='humidityMinThresholdCritical'
                        startValue={defaultValues ? defaultValues.humidityMinThreshold : 0}
                        min={0}
                        max={100}
                        step={0.1}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="Umidade Superior Crítica (%)"
                        name='humidityMaxThresholdCritical'
                        startValue={defaultValues ? defaultValues.humidityMaxThreshold : 0}
                        min={0}
                        max={100}
                        step={0.1}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="CO2 Inferior Crítica (PPM)"
                        name='cO2MinThresholdCritical'
                        startValue={defaultValues ? defaultValues.cO2MinThreshold : 0}
                        min={0}
                        max={10000}
                        step={100}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="CO2 Superior Crítica (PPM)"
                        name='cO2MaxThresholdCritical'
                        startValue={defaultValues ? defaultValues.cO2MaxThreshold : 0}
                        min={0}
                        max={10000}
                        step={100}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="Vibração Mecânica Inferior Crítica (g)"
                        name='vibrationMinThresholdCritical'
                        startValue={defaultValues ? defaultValues.vibrationMinThreshold : 0}
                        min={0.0}
                        max={10.0}
                        step={0.1}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="Vibração Mecânica Superior Crítica (g)"
                        name='vibrationMaxThresholdCritical'
                        startValue={defaultValues ? defaultValues.vibrationMaxThreshold : 0}
                        min={0.0}
                        max={10.0}
                        step={0.1}
                        disable={defaultValues ? false : true}
                    />
                </Grid>

            </Grid>
        </FormLayout>
    );
}